import { HttpInterceptorFn } from '@angular/common/http';

import { ClientConfigProductName, provideLazyHttpInterceptor } from '@frontend/vanilla/core';

export function provideLazySportsHttpInterceptors(): HttpInterceptorFn[] {
    return [
        provideLazyHttpInterceptor(ClientConfigProductName.SPORTS, () =>
            import('@frontend/sports/http/feature').then(({ sessionExpirationInterceptor }) => sessionExpirationInterceptor),
        ),
        provideLazyHttpInterceptor(ClientConfigProductName.SPORTS, () =>
            import('@frontend/sports/http/feature').then(({ apiVersioningInterceptor }) => apiVersioningInterceptor),
        ),
        provideLazyHttpInterceptor(ClientConfigProductName.SPORTS, () =>
            import('@frontend/sports/http/feature').then(({ connectionLostInterceptor }) => connectionLostInterceptor),
        ),
        provideLazyHttpInterceptor(ClientConfigProductName.SPORTS, () =>
            import('@frontend/sports/http/feature').then(({ pendingRequestsInterceptor }) => pendingRequestsInterceptor),
        ),
        provideLazyHttpInterceptor(ClientConfigProductName.SPORTS, () =>
            import('@frontend/sports/http/feature').then(({ provideDuplicateBetplacementInterceptor }) => provideDuplicateBetplacementInterceptor()),
        ),
    ];
}
